import subscribeFilterTabs from "./filterTabs";

const initSubscriptions = (stompClient) => {
  setTimeout(() => {
    subscribeFilterTabs(stompClient);
  }, 0);
};

export default initSubscriptions;
